import React from "react";
import '../styles.css';

export default function Header(){
    return(
    <div className="header">
        <img className="logo" src="someplans.png" alt="someplans"></img>
        <br></br>
        <h2 className="app-subtitle">It's time to make some plans.</h2>
    </div>);
}

